/**
 * Stopwords stripped before indexing and querying.
 *
 * Two layers:
 *   • English stopwords — the usual NL noise that never carries query intent.
 *   • Domain stopwords — words that appear in nearly every tour ("click",
 *     "button", "page", "tour") and would otherwise dominate BM25 scores.
 *     If users start asking literal questions about UI primitives we can
 *     promote some of these back; for "how do I reset a password?" they
 *     are pure noise.
 */
export const STOPWORDS: ReadonlySet<string> = new Set([
  // English
  'a', 'an', 'and', 'are', 'as', 'at', 'be', 'but', 'by', 'do', 'does', 'for',
  'from', 'how', 'i', 'if', 'in', 'into', 'is', 'it', 'its', 'me', 'my', 'no',
  'not', 'of', 'on', 'or', 'so', 'than', 'that', 'the', 'their', 'then',
  'there', 'these', 'they', 'this', 'to', 'was', 'were', 'what', 'when',
  'where', 'which', 'who', 'why', 'will', 'with', 'you', 'your',
  // Domain — see file header
  'click', 'clicks', 'button', 'page', 'tour', 'tours', 'screen', 'panel',
  'open', 'opens', 'opening', 'show', 'shows', 'showing', 'use', 'using',
  'guide', 'walkthrough',
]);
